import React, { useState } from "react";

import { HiMenuAlt4 as MenuIcon } from "react-icons/hi";
import { IoCloseSharp as CloseIcon } from "react-icons/io5";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <header className="p-4  w-screen h-auto flex items-center text-2xl justify-between">
        <div className="font-bold">
          Portfo
          <span className="text-[#DD2574]">lio.</span>
        </div>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="fixed top-5 bg-white transition-all shadow duration-200 p-3 rounded-full right-5 z-20 block cursor-pointer text-slate-800"
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </header>
      {menuOpen && (
        <div className="fixed flex items-center justify-center top-0 left-0 h-screen w-screen bg-white z-10">
          <div className="w-full flex flex-col gap-3 text-right p-3 capitalize">
            <a
              href="#home"
              className="text-6xl font-black "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
                Home
              </span>
            </a>

            <a
              href="#about"
              className="text-6xl font-black group "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gray-400 hover:bg-black transition-all duration-200">
                About
              </span>
            </a>

            <a
              href="#skills"
              className="text-6xl font-black group "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gray-400 hover:bg-black transition-all duration-200">
                Skills
              </span>
            </a>

            {/* <a
              href="#service"
              className="text-6xl font-black group "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gray-400 hover:bg-black transition-all duration-200">
                Services
              </span>
            </a> */}

            <a
              href="#projects"
              className="text-6xl font-black group "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gray-400 hover:bg-black transition-all duration-200">
                Projects
              </span>
            </a>

            <a
              href="#contact"
              className="text-6xl font-black group "
              onClick={() => setMenuOpen(false)}
            >
              <span className="md:text-6xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gray-400 hover:bg-black transition-all duration-200">
                Contact
              </span>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
